(function () {
  var SESSION_KEY = "amazing-chatbot-session-id";
  var RESET_PARAMS = ["amazing_chatbot_reset", "acb_reset"];

  function clearChatbotStorageIfRequested() {
    var url;
    try {
      url = new URL(window.location.href);
    } catch (_err) {
      return;
    }
    var shouldReset = RESET_PARAMS.some(function (param) {
      var value = url.searchParams.get(param);
      return value === "1" || value === "true";
    });
    if (!shouldReset) return;
    try {
      for (var i = window.localStorage.length - 1; i >= 0; i -= 1) {
        var key = window.localStorage.key(i);
        if (key && key.indexOf("amazing-chatbot") === 0) {
          window.localStorage.removeItem(key);
        }
      }
    } catch (_err) {
      // Storage can be unavailable in private or locked-down browsers.
    }
    RESET_PARAMS.forEach(function (param) {
      url.searchParams.delete(param);
    });
    try {
      window.history.replaceState(window.history.state, "", url.toString());
    } catch (_err) {
      // If history is unavailable, leaving the query param is harmless.
    }
  }

  function getSessionId(config) {
    var storageKey = SESSION_KEY + ":" + (config.tenantId || config.shopDomain || "store");
    try {
      var existing = window.localStorage.getItem(storageKey);
      if (existing) return existing;
      var generated = "shopify-" + (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(Date.now()) + "-" + Math.random().toString(36).slice(2));
      window.localStorage.setItem(storageKey, generated);
      return generated;
    } catch (_err) {
      return "shopify-" + String(Date.now()) + "-" + Math.random().toString(36).slice(2);
    }
  }

  function storefrontConfigUrl(config) {
    if (!config.endpoint) return "";
    var base = config.endpoint.replace(/\/api\/chat(?:\/stream)?$/, "");
    if (!base || base === config.endpoint) return "";
    var params = [];
    if (config.tenantId) params.push("tenantId=" + encodeURIComponent(config.tenantId));
    if (config.shopDomain) params.push("shop=" + encodeURIComponent(config.shopDomain));
    if (!params.length) return "";
    return base + "/api/storefront/config?" + params.join("&");
  }

  function storefrontEventsUrl(config) {
    if (!config.endpoint) return "";
    var base = config.endpoint.replace(/\/api\/chat(?:\/stream)?$/, "");
    if (!base || base === config.endpoint) return "";
    return base + "/api/storefront/events";
  }

  function applyRemoteConfig(config, remote) {
    if (!remote || typeof remote !== "object") return config;
    return Object.assign({}, config, {
      // Dashboard kill switch: only an explicit false hides the widget, so a
      // config outage or older API response fails open and keeps it mounted.
      assistantEnabled: remote.enabled !== false,
      title: remote.title || config.title,
      greeting: remote.greeting || config.greeting,
      primaryColor: remote.primary_color || remote.primaryColor || config.primaryColor,
      launcherIconUrl: remote.launcher_icon_url || remote.launcherIconUrl || config.launcherIconUrl,
      avatarIconUrl: remote.avatar_icon_url || remote.avatarIconUrl || config.avatarIconUrl,
      triggers: Array.isArray(remote.triggers) ? remote.triggers : config.triggers
    });
  }

  function fetchRemoteConfig(config) {
    var url = storefrontConfigUrl(config);
    if (!url || !window.fetch) return Promise.resolve(config);
    return window.fetch(url, { credentials: "omit", mode: "cors" })
      .then(function (response) {
        if (!response.ok) return config;
        return response.json().then(function (remote) {
          return applyRemoteConfig(config, remote);
        });
      })
      .catch(function () {
        return config;
      });
  }

  function mount(config, sessionId) {
    var launcherIcon = config.launcherIconUrl || config.avatarIconUrl || config.logoUrl || config.launcherIcon;
    var avatarIcon = config.avatarIconUrl || config.launcherIconUrl || config.logoUrl || false;
    window.amazingChatbot.mount({
      endpoint: config.endpoint,
      title: config.title || "Store assistant",
      greeting: config.greeting || "Need a hand choosing the right gear? Tell me what you're dealing with and I'll point you toward the best fit.",
      launcherIcon: launcherIcon,
      avatar: avatarIcon,
      sessionId: sessionId,
      eventsEndpoint: storefrontEventsUrl(config),
      proactiveTriggers: Array.isArray(config.triggers) ? config.triggers : [],
      pageUrl: window.location.pathname + window.location.search,
      theme: { primary: config.primaryColor || "#111318" },
      context: function () {
        return {
          tenantId: config.tenantId,
          shop: config.shopDomain,
          sessionId: sessionId,
          page: config.page,
          product: config.product,
          collection: config.collection,
          cart: config.cart
        };
      }
    });
  }

  function mountWhenReady() {
    clearChatbotStorageIfRequested();
    var config = window.__amazingChatbotConfig;
    if (!config || !window.amazingChatbot) {
      window.setTimeout(mountWhenReady, 50);
      return;
    }
    var sessionId = getSessionId(config);
    fetchRemoteConfig(config).then(function (resolvedConfig) {
      if (resolvedConfig.assistantEnabled === false) return;
      mount(resolvedConfig, sessionId);
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mountWhenReady);
  } else {
    mountWhenReady();
  }
})();
